import { ImpressionLog, ItemAttributes, ItemType } from '../../types/messaging-types';

import { checkIsTrueOrThrow } from '../../server/utils/preconditions';
import _ from 'lodash';

// All the attributes in ConversationImpressionLog except conversationSids
const CONVERSATION_IMPRESSION_LOG_SCHEMA = [
    'folders',
    'hasCompanyName',
    'hasTitleLink',
    'isArchived',
    'isInitiated',
    'isOld',
    'positions',
    'reminders',
    'requireResponse',
    'types',
    'unreadCounts',
    'isPreApply',
];

// All the attributes in JobDetailImpressLog except conversationSids
const JOB_DETAIL_IMPRESSION_LOG_SCHEMA = [
    'hasCompanyName',
    'hasJobSetting',
    'hasJobShift',
    'hasJobTitle',
    'hasJobType',
    'hasJobUrl',
    'hasLocation',
    'hasLogoUrl',
    'hasRating',
    'jobKey',
];

// tslint:disable-next-line: no-any
const validateAttributeFn = (size: number) => {
    // tslint:disable-next-line: no-any
    return (attribute: any) => {
        checkIsTrueOrThrow(_.isArray(attribute), `${attribute} is not array: ${attribute}`);
        checkIsTrueOrThrow(
            attribute.length === size,
            `${attribute} length: ${attribute.length} doesn't match conversationSidsLength: ${attribute}`
        );
    };
};

const validateConversationSids = (conversationSids: string[]) => {
    checkIsTrueOrThrow(
        _.isArray(conversationSids),
        `conversationSids is not array: ${conversationSids}`
    );
    checkIsTrueOrThrow(conversationSids.length > 0, 'conversationSids are empty');
};

export const convertImpressionLog = (
    // tslint:disable-next-line:no-any
    log: any,
    itemType: ItemType
): ImpressionLog => {
    const { conversationSids } = log;
    validateConversationSids(conversationSids);
    delete log.conversationSids;
    const attrValidator = validateAttributeFn(conversationSids.length);
    switch (itemType) {
        case ItemType.JOB_DETAIL:
            // tslint:disable-next-line: no-void-expression
            JOB_DETAIL_IMPRESSION_LOG_SCHEMA.forEach((key: string) => attrValidator(log[key]));
            break;
        case ItemType.CONVERSATIONS:
            // tslint:disable-next-line: no-void-expression
            CONVERSATION_IMPRESSION_LOG_SCHEMA.forEach((key: string) => attrValidator(log[key]));
            break;
    }

    return {
        itemType,
        itemUids: conversationSids,
        itemsAttributes: log as ItemAttributes,
    };
};
